import { writable } from "svelte/store";
let OrderDeliveryStore;
export default OrderDeliveryStore = writable(null);
